/* Skinko – efectos al agregar al carrito: brillo "glass skin", destellos rosa/lila y aviso flotante. */
(function () {
  if (window.SkinkoCartFX) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['#e62889', '#bba0f2', '#7980fc', '#ff9ccf', '#ffffff'];

  var css = '' +
    '.sk-shine{position:relative!important;overflow:hidden!important}' +
    '.sk-shine::after{content:"";position:absolute;top:0;left:-70%;width:55%;height:100%;pointer-events:none;' +
      'background:linear-gradient(105deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.85) 45%,rgba(255,214,236,.6) 55%,rgba(255,255,255,0) 100%);' +
      'transform:skewX(-20deg);animation:skShine .9s cubic-bezier(.3,.7,.4,1) forwards}' +
    '@keyframes skShine{to{left:140%}}' +
    '.sk-spark{position:fixed;z-index:10000;pointer-events:none;width:12px;height:12px;margin:-6px 0 0 -6px}' +
    '.sk-spark svg{display:block;width:100%;height:100%;filter:drop-shadow(0 0 3px rgba(230,40,137,.45))}' +
    '.wt-cart__trigger.sk-bump{animation:skPop .55s ease-out}' +
    '@keyframes skPop{0%{transform:scale(1)}35%{transform:scale(1.25) rotate(-6deg)}70%{transform:scale(.95)}100%{transform:scale(1)}}' +
    '.sk-toast{position:fixed;left:50%;bottom:88px;z-index:10001;display:flex;align-items:center;gap:12px;max-width:calc(100% - 32px);' +
      'padding:10px 16px;border-radius:999px;background:rgba(255,255,255,.94);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);' +
      'border:1px solid rgba(187,160,242,.7);box-shadow:0 10px 30px rgba(121,128,252,.25);color:#10151a;font-size:14px;line-height:1.2;' +
      'transform:translate(-50%,16px);opacity:0;visibility:hidden;transition:opacity .2s ease,transform .2s ease,visibility 0s linear .2s;white-space:nowrap}' +
    '.sk-toast span{white-space:nowrap}' +
    '.sk-toast.is-on{opacity:1;visibility:visible;transform:translate(-50%,0);transition:opacity .2s ease,transform .2s ease,visibility 0s}' +
    '.sk-toast button{all:unset;cursor:pointer;color:#e62889;font-weight:600;text-decoration:underline;white-space:nowrap}' +
    '@media (min-width:990px){.sk-toast{bottom:32px}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var STAR = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 0c.6 5.6 3.4 9.4 12 12-8.6 2.6-11.4 6.4-12 12-.6-5.6-3.4-9.4-12-12C8.6 9.4 11.4 5.6 12 0z"/></svg>';

  function burst(el, count) {
    if (reduce || !el || !el.getBoundingClientRect) return;
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return;
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      s.className = 'sk-spark';
      s.innerHTML = STAR;
      s.style.color = COLORS[i % COLORS.length];
      s.style.left = cx + 'px';
      s.style.top = cy + 'px';
      var size = 8 + Math.random() * 10;
      s.style.width = s.style.height = size + 'px';
      document.body.appendChild(s);
      var ang = (Math.PI * 2 * i) / count + Math.random() * 0.6;
      var dist = Math.max(r.width, r.height) * 0.45 + 20 + Math.random() * 30;
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 10;
      var anim = s.animate([
        { transform: 'translate(0,0) scale(.2) rotate(0deg)', opacity: 0 },
        { transform: 'translate(' + dx * 0.6 + 'px,' + dy * 0.6 + 'px) scale(1.1) rotate(90deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.3) rotate(180deg)', opacity: 0 }
      ], { duration: 750 + Math.random() * 250, easing: 'cubic-bezier(.2,.7,.3,1)' });
      anim.onfinish = (function (n) { return function () { n.remove(); }; })(s);
      setTimeout((function (n) { return function () { if (n.isConnected) n.remove(); }; })(s), 1500);
    }
  }

  function shine(btn) {
    if (reduce || !btn) return;
    btn.classList.remove('sk-shine');
    void btn.offsetWidth;
    btn.classList.add('sk-shine');
    setTimeout(function () { btn.classList.remove('sk-shine'); }, 950);
  }

  function bumpCart() {
    var t = document.querySelector('.wt-cart__trigger');
    if (!t) return;
    burst(t, 8);
    t.classList.remove('sk-bump');
    void t.offsetWidth;
    t.classList.add('sk-bump');
    setTimeout(function () { t.classList.remove('sk-bump'); }, 600);
  }

  var toastEl, toastTimer;
  function toast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sk-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML = '<span>✨ Agregado al carrito</span><button type="button">Ver carrito</button>';
      toastEl.querySelector('button').addEventListener('click', function () {
        hideToast();
        var trig = document.querySelector('.wt-cart__trigger');
        if (trig) trig.click(); else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
      document.body.appendChild(toastEl);
      void toastEl.offsetWidth;
    }
    clearTimeout(toastTimer);
    toastEl.classList.add('is-on');
    toastTimer = setTimeout(hideToast, 3200);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-on'); }

  function labelSwap(btn) {
    if (!btn) return;
    var span = btn.querySelector('span:not(.sk-qa__check):not(.loading-overlay__spinner)');
    if (!span || !span.textContent.trim()) return;
    if (!span.dataset.skOriginal) span.dataset.skOriginal = span.textContent;
    span.textContent = '¡Agregado! ✨';
    setTimeout(function () { span.textContent = span.dataset.skOriginal; }, 1600);
  }

  window.SkinkoCartFX = {
    celebrate: function (btn, opts) {
      opts = opts || {};
      shine(btn);
      burst(btn, opts.sparks || 12);
      if (opts.label !== false) labelSwap(btn);
      bumpCart();
      if (opts.toast) toast();
    },
    toast: toast
  };
})();
